import { CoreState } from '../../../models';
import { CORE_MUTATIONS_KEYS } from '../core.const';
import { CoreMutation } from '../core.interfaces';

export class SetUserAcceptedQueryMutation implements CoreMutation {
  mutations = {
    [CORE_MUTATIONS_KEYS.setUserAcceptedQuery]: (localState: CoreState, userAcceptedQuery: string) => {
      localState.userAcceptedQuery = userAcceptedQuery;
    }
  };
}
